export default __webpack_public_path__ + "static/media/bailey_sign_500.f7a62a93.webp";